import {
  IError,
  IProfileConsentManagement,
  IQueryHookOptions,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { clearConsent } from 'services';

type ClearConsentFunction = UseMutateAsyncFunction<
  IProfileConsentManagement,
  IError
>;

type UseClearConsent = [ClearConsentFunction, IQueryHookOptions];

export const useClearConsent = (profileId = ''): UseClearConsent => {
  const queryClient = useQueryClient();

  const { error, isError, isLoading, mutateAsync } = useMutation<
    IProfileConsentManagement,
    IError
  >(() => clearConsent(profileId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['consentManagement', profileId]);
    },
  });

  return [mutateAsync, { error, isError, isLoading }];
};
